import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useAsanImzaService } from 'app/utils/services/asanImzaService';
import useRedirectWithFormId from 'app/utils/customHooks/useRedirectWithFormId';

interface Props {
  pathUrl?: any;
  businessKey?: any;
  asanModalType?: any;
}

const useConfirmAsanImza = (props: Props) => {
  const { t } = useTranslation();
  const { pathUrl, businessKey, asanModalType } = props;
  const ref = useRef(null);
  const location = useLocation();
  const data = location.state;

  const { dataAsanImza, asanImzaMutation } = useAsanImzaService();
  const { handleRedirect } = useRedirectWithFormId();
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const handleCheckNumber = () => {
    if (pathUrl !== undefined) {
      asanImzaMutation({
        data: { action: 'check' },
        url: `${pathUrl}?business_key=${businessKey}`,
      });
    } else {
      asanImzaMutation({
        data: { action: 'check', form_id: 'authorization_b2b' },
        url: `/api-web/v1/main/authorization_b2b?business_key=${data?.business_key}`,
      });
    }
  };

  const handleCancel = () => {
    if (pathUrl !== undefined) {
      asanImzaMutation({
        data: { action: 'cancel' },
        url: `${pathUrl}?business_key=${businessKey}`,
      });
    } else {
      asanImzaMutation({
        data: { action: 'cancel', form_id: 'authorization_b2b' },
        url: `/api-web/v1/main/authorization_b2b?business_key=${data?.business_key}`,
      });
    }
  };

  useEffect(() => {
    if (asanModalType === 'transfer') {
      if (!dataAsanImza?.error && dataAsanImza?.form_id !== 'success_action') {
        ref.current = setTimeout(() => handleCheckNumber(), 5000);
      }
    } else {
      if (!dataAsanImza?.error) {
        ref.current = setTimeout(() => handleCheckNumber(), 5000);
      }
    }

    if (dataAsanImza?.form_id !== 'asan_wait') {
      handleRedirect(dataAsanImza);
    }

    if (dataAsanImza?.form_id === 'success_action') {
      setSuccessModal(true);
    }

    if (dataAsanImza?.form_id === 'error') {
      setErrorModal(true);
    }

    return () => {
      if (ref.current) {
        clearTimeout(ref.current);
      }
    };
  }, [dataAsanImza]);

  const handleRepeatCode = () => {
    if (pathUrl !== undefined) {
      asanImzaMutation({
        data: { action: 'repeat_code' },
        url: `${pathUrl}?business_key=${businessKey}`,
      });
    } else {
      asanImzaMutation({
        data: { action: 'repeat_code', form_id: 'authorization_b2b' },
        url: `/api-web/v1/main/authorization_b2b?business_key=${data?.business_key}`,
      });
    }
  };

  return {
    t,
    data,
    dataAsanImza,
    handleRepeatCode,
    handleCancel,
    successModal,
    setSuccessModal,
    errorModal,
    setErrorModal,
  };
};

export default useConfirmAsanImza;
